import {useEffect, useState} from "react";
import {getRememberedDepartureAirport, rememberDepartureAirport} from "@/utils/rememberedDepartureAirport.js";

const FlyingFromLocation = ({ onLocationChange, initSearchValue = ""}) => {
    const [searchValue, setSearchValue] = useState(initSearchValue);
    const [selectedItem, setSelectedItem] = useState(null);
    const [availableDepartureLocations, setAvailableDepartureLocations] = useState([]);
    const [filteredLocations, setFilteredLocations] = useState([]);

    // Pre-fill from the last airport this visitor picked - but only when the caller didn't
    // already pass an explicit initial value (e.g. the /flights page re-opening a specific past
    // search via its URL params). This is a convenience default for a blank box, not something
    // that should fight an explicit selection, and it's still fully changeable either way.
    useEffect(() => {
        if (initSearchValue) return;
        const remembered = getRememberedDepartureAirport();
        if (!remembered) return;
        const item = {
            id: "remembered",
            name: remembered.name,
            address: "Kod lotniska: " + remembered.code,
            code: remembered.code,
        };
        setSearchValue(remembered.name);
        setSelectedItem(item);
        onLocationChange(item);
        // Deliberately mount-only: re-firing this on every initSearchValue/onLocationChange
        // identity change would fight the user's own in-session selection.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        fetch('https://api.tripsi.pl/api/trips/data/airports/departure?test=test')
            .then(response => response.json())
            .then(data => {
                let allAirports = [{
                    id: 1,
                    name: "Polska",
                    address: "Dowolne lotnisko na terenie polski",
                }]
                let idCounter = 1;
                for(let [code, name] of Object.entries(data)) {
                    let airport = {
                        id: idCounter++,
                        name: name,
                        address: "Kod lotniska: " + code,
                        code: code
                    }
                    allAirports.push(airport)
                }
                console.log("Setting to ", allAirports)
                setAvailableDepartureLocations(allAirports)
            })
            .catch(error => console.error('Error:', error));
    }, []);

    useEffect(() => {
        setFilteredLocations(
            availableDepartureLocations.filter(
                location =>
                    (searchValue === null || searchValue === "") ||
                    (location.name || '').toLowerCase().startsWith(searchValue.toLowerCase())
            )
        );
    }, [searchValue, availableDepartureLocations]);

    const handleOptionClick = (item) => {
        setSearchValue(item.name);
        setSelectedItem(item);
        onLocationChange(item);
        // The "Polska" catch-all option has no `code` - nothing meaningful to remember there.
        if (item.code) {
            rememberDepartureAirport(item.code, item.name);
        }
    };

    return (
        <>
            <div className="searchMenu-loc px-24 lg:py-20 lg:px-0 js-form-dd js-liverSearch">
                <div
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="true"
                    data-bs-offset="0,22"
                >
                    <h4 className="text-15 fw-500 ls-2 lh-16">Podróż z</h4>
                    <div className="text-15 text-light-1 ls-2 lh-16">
                        <input
                            autoComplete="off"
                            type="search"
                            placeholder="Polska"
                            aria-label="Podróż z"
                            className="js-search js-dd-focus"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                        />
                    </div>
                </div>

                <div className="shadow-2 dropdown-menu min-width-400">
                    <div className="bg-white px-20 py-20 sm:px-0 sm:py-15 rounded-4">
                        <ul className="y-gap-5 js-results">
                            {filteredLocations.map((item) => (
                                <li
                                    className={`-link d-block col-12 text-left rounded-4 px-20 py-15 js-search-option mb-1 ${
                                        selectedItem && selectedItem.id === item.id ? "active" : ""
                                    }`}
                                    key={item.id}
                                    role="button"
                                    onClick={() => handleOptionClick(item)}
                                >
                                    <div className="d-flex">
                                        <div className="icon-location-2 text-light-1 text-20 pt-4" />
                                        <div className="ml-10">
                                            <div className="text-15 lh-12 fw-500 js-search-option-target">
                                                {item.name}
                                            </div>
                                            <div className="text-14 lh-12 text-light-1 mt-5">
                                                {item.address}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FlyingFromLocation;